module.exports = __webpack_public_path__ + "static/media/img-mygood-screen.f82e69ee.png";